import React from 'react';
import { 
  Box,
  IcoMoon,
  Text,
  BoxPinkIcon,
  PrintPinkIcon,
  TruckPinkIcon,
} from "@usap/uicomponents";

export default function PrepaidShippingLabel({ isDesktop }) {
  return (
      <>
        <Box pad="medium">
          <Text size={isDesktop ? 'small' : 'large'} color="dark-2" weight="bold">
            Here’s how to get your item(s) back to us:
          </Text>
        </Box>
        <Box align="center">
          <Box direction="row" pad="small" align="center">
            <Box width="xxsmall" margin={{ right: '16px' }}>
              <IcoMoon icon={PrintPinkIcon} />
            </Box>
            <Box width={isDesktop ? 'medium' : 'small'}>
              <Text size="xsmall">
                1. Print your Shipping Label. No printer? No worries!
                You can pull up this Shipping Label
                from your return confirmation email or return history in
                your account and print at your convenience.
              </Text>
            </Box>
          </Box>

          <Box direction="row" pad="small" align="center">
            <Box width="xxsmall" margin={{ right: '16px' }}>
              <IcoMoon icon={BoxPinkIcon} />
            </Box>
            <Box width={isDesktop ? 'medium' : 'small'}>
              <Text size="xsmall">
                2. Pack your items with the return
                form and attach the Shipping Label to your package.
                Make sure any old barcodes or markings on the package are covered.
              </Text>
            </Box>
          </Box>

          <Box direction="row" pad="small" align="center">
            <Box width="xxsmall" margin={{ right: '16px' }}>
              <IcoMoon icon={TruckPinkIcon} />
            </Box>
            <Box width={isDesktop ? 'medium' : 'small'}>
              <Text size="xsmall">
                3. Ship your return at any FedEx location near you.
                We&apos;ll email you when your package arrives and
                your return is being processed.
              </Text>
            </Box>
          </Box>
        </Box>
      </>
  )
}
